import { render, staticRenderFns } from "./References.vue?vue&type=template&id=3d676f30&scoped=true"
import script from "./References.vue?vue&type=script&lang=js"
export * from "./References.vue?vue&type=script&lang=js"
import style0 from "./References.vue?vue&type=style&index=0&id=3d676f30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d676f30",
  null
  
)

export default component.exports